module.exports = __webpack_public_path__ + "img/pack_up.674cac1f.svg";